// ====================================================================================
// _template.module
// ====================================================================================
// import $ from "jquery";

// ====================================================================================
// CSS - Integrate directly into html
// ====================================================================================

export const init = () => {
  let attempts = 0;

  // if document.ready needed
  const whenComplete = () => {
    if (++attempts > 30) return;
    if (document.readyState === "complete") {
      main();
    } else {
      setTimeout(() => whenComplete(), 400);
    }
  };

  whenComplete();
};

function main(){

      // #######################################################################################################
  // CCMOpener
  // #######################################################################################################
    document.querySelectorAll("li.CCMOpener > a").forEach(function (link) {
      link.addEventListener("click", function (e) {
          e.preventDefault(); // Verhindert das Standardverhalten (Seitenwechsel)
          if (
              typeof CCM !== "undefined" &&
              typeof CCM.openWidget === "function"
          ) {
              CCM.openWidget();
          } else {
              console.warn("CCM.openWidget() ist nicht definiert.");
          }
      });
  });

}